import React from "react";
import FormConfig from '../../Config/FormConfig.js'
import APIService from "../../Service/APIService";
import { Formik, Form, Field } from 'formik';
import Config from "../../Config/Config.js";
// import OrderProducts from "./OrderProducts";
import OrderProducts from "./OP";
import * as yup from 'yup';
import { Spin, Flex, Tag, Modal, Row, Col, Input, Button, Table, InputNumber, DatePicker, Switch } from 'antd';
import { useParams } from 'react-router-dom';
import { useState } from "react";
import { CheckOutlined, LogoutOutlined, PlusOutlined, PlusSquareOutlined, ClearOutlined } from '@ant-design/icons';
import './DirectOrder.css'
import CustomHeader from "../CustomHeader/CustomHeader";
import Swal from 'sweetalert2';
import Text from '../../common/typography/text';
// import moment from 'moment';
import { LoadingOutlined } from '@ant-design/icons';
import Select from 'react-select';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import AddContactForm from './AddContactForm';
import { useAuth } from '../AuthProvider.js';
import { hasPermission } from '../../Config/permissions.js';
import { useNavigate } from "react-router-dom";

dayjs.extend(utc);

const { TextArea } = Input;

const normalizeDirectOrderPaymentStatus = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

const PREPAID_DIRECT_ORDER_SUCCESS_STATUSES = new Set([
  "approved",
  "completed",
  "payment successful",
  "paid",
  "success",
  "succeeded",
]);

const isPrepaidDirectOrderAdminActionLocked = (order) => {
  if (!Boolean(order?.PrepaidOrder)) {
    return false;
  }

  return !PREPAID_DIRECT_ORDER_SUCCESS_STATUSES.has(
    normalizeDirectOrderPaymentStatus(order?.Status),
  );
};

const getApiErrorMessage = (error, fallback) =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  error?.response?.data?.data ||
  error?.message ||
  fallback;

const DirectOrder = (props) => {
  const { user, isReady } = useAuth();
  const userData = user;
  // const {userData} = props;
  const navigate = useNavigate();
  const params = useParams();
  const [fieldsArr, setFieldsArr] = React.useState([]);
  const [initialValues, setInitialValues] = React.useState(null);
  const [validationSchema, setValidationSchema] = React.useState(null);
  const [accountOptions, setAccountOptions] = React.useState(null);
  const [relatedAccountOptions, setRelatedAccountOptions] = React.useState([]);
  const [manufacturerOptions, setManufacturerOptions] = React.useState([]);
  const [productColumns, setProductColumns] = React.useState([]);
  const [productData, setProductData] = React.useState([]);
  const [orderProducts, setOrderProducts] = React.useState([]);
  const [isEditable, setIsEditable] = useState(false);
  // const [orderDetails, setOrderDetails] = useState(null);
  const [orderTotal, setOrderTotal] = React.useState(0);
  const [numberOfProducts, setNumberOfProducts] = React.useState(0);
  const [disableCaseID, setDisableCaseID] = React.useState(false);

  const handleOrderProducts = (orderProds, total, numProducts) => {
    console.log("Order Products from DO Page ", orderProds);
    setDisableCaseID(true);
    // console.log("Number of Products: ", numProducts);
    // console.log("Order Total: ", total);
    setOrderProducts(orderProds);
    setNumberOfProducts(numProducts);
    setOrderTotal(total);
  };

  const generateValidationSchema = (formFieldArr) => {
    let obj = {}; // schema object
    for (const cur of formFieldArr) {
      obj[cur.backendName] = cur.validationFunction;
    }
    return obj;
  }

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    console.log("Data: ", data);
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] =
          cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    console.log("Initial Values:", obj);
    return obj;
  }

  const [accountsData, setAccountsData] = React.useState(null);

  const getAccountOptions = async () => {
    const serv = new APIService();
    // const options = await serv.getDataFromBackend("getaccounts");
    const userType = userData.Type;
    const options = await serv.getDataFromBackend(`account/directorder`);
    setAccountsData(options?.data?.Accounts);
    let tempOptions = [];
    options?.data?.Accounts.map((ele) => {
      tempOptions.push({
        ...ele,
        value: ele.ID,
        label: ele.AccountName,
        ParentAccountID: ele.ParentAccountID,
      });
    });
    setAccountOptions(tempOptions);
    return tempOptions;
  }

  const [doData, setDoData] = React.useState(null);
  const getOrderByID = async (ID) => {
    const serv = new APIService();
    const response = await serv.getDataFromBackend(`getdobyid?ID=${ID}`);
    console.log("Order Data: ", response?.data?.data);
    setDoData(response?.data?.data.DirectOrder);
    return response?.data?.data;
  }

  React.useEffect(() => {
    let val = null;
    if (params?.id == null || params?.id == undefined) {
      console.log("No ID");
      val = generateFieldsArray(null);
      console.log("Fields Array: ", val);
      setValidationSchema(yup.object().shape(generateValidationSchema(val)));
      setIsEditable(true);
      let tempAccOptions = null;
      getAccountOptions().then((data) => {
        tempAccOptions = data;
      });
    }
    else {
      console.log("Account ID: ", params.id);
      let tempData = null;
      getOrderByID(params.id).then(async (data) => {
        if(userData.Type == "Manufacturer"){
          if(data?.DirectOrder?.ManufacturerID !== userData.ManufacturerID){
            navigate(`/Manufacturer/${userData?.ManufacturerID}`);
          }
        }
        if(userData.Type == "Account"){
          if(data?.DirectOrder?.AccountID !== userData.AccountID){
            navigate(`/Account/${userData?.AccountID}`);
          }
        }
        if(userData.Type == "Distributor"){
          if(data?.DirectOrder?.DistributorID !== userData.DistributorID){
            navigate(`/Distributor/${userData?.DistributorID}`);
          }
        }
        tempData = data;
        setOrderProducts(tempData?.OrderProducts);
        // await handleSelectChange(tempData?.DirectOrder?.AccountID, "AccountID", tempAccOptions);
        await getProductsFromManufacturer(tempData?.DirectOrder?.ManufacturerID);
        val = generateFieldsArray(data.DirectOrder);
        setValidationSchema(yup.object().shape(generateValidationSchema(val)));
      });
    }
  }, [])

  const [accId, setAccId] = React.useState(null);
  const [manId, setManId] = React.useState(null);

  const generateFieldsArray = (data) => {
    const doFields = FormConfig.CreateDirectOrderForm;
    const val = generateInitialValues(doFields, data);
    console.log("Initial Values: ", val);

    val["OrderPlacedBy"] = (params?.id !== null && params?.id !== undefined) ? val["OrderPlacedBy"] : userData.FirstName + " " + userData.LastName;
    val["OrderPlacedByEmail"] = ((params?.id !== null && params?.id !== undefined) ? val["OrderPlacedByEmail"] : userData.Email);
    val["OrderType"] = "DO";
    // val["OrderDate"] = val["OrderDate"] === null ? moment() : moment(val["OrderDate"]);
    val["OrderDate"] = (params?.id === null || params?.id === undefined) ? dayjs() : dayjs((val["OrderDate"]));
    // val["ApprovedDate"] = val["ApprovedDate"] === null ? moment() : moment(val["ApprovedDate"]);
    val["ApprovedDate"] = val["ApprovedDate"] === null ? dayjs() : dayjs(val["ApprovedDate"]);
    // val["RejectedDate"] = val["RejectedDate"] === null ? moment() : moment(val["RejectedDate"]);
    val["RejectedDate"] = val["RejectedDate"] === null ? dayjs() : dayjs(val["RejectedDate"]);
    // val["DateOfApplication"] = val["DateOfApplication"] === null ? null : moment(val["DateOfApplication"]);
    val["DateOfApplication"] = val["DateOfApplication"] === null ? null : dayjs(val["DateOfApplication"]);
    // val["RequestedDeliveryDate"] = val["RequestedDeliveryDate"] === null ? null : moment(val["RequestedDeliveryDate"]);
    val["RequestedDeliveryDate"] = val["RequestedDeliveryDate"] === null ? null : dayjs(val["RequestedDeliveryDate"]);
    val["ApprovedBy"] = val["ApprovedBy"] === "Pending" ? userData.FirstName + " " + userData.LastName : val["ApprovedBy"];
    val["RejectedBy"] = val["RejectedBy"] === "Pending" ? userData.FirstName + " " + userData.LastName : val["RejectedBy"];
    // val["ShippingPreference"] = "Priority Overnight by 10:30am";
    val["PatientLastName"] = val["PatientLastName"] ?? "";
    val["PatientFirstName"] = val["PatientFirstName"] ?? "";
    val["PrepaidOrder"] = Boolean(data?.PrepaidOrder);
    if (params?.id !== null && params?.id !== undefined) {
      setAccId(val["AccountID"]);
      setManId(val["ManufacturerID"]);
    }
    setNumberOfProducts(val["NumberOfProducts"]);
    setOrderTotal(val["OrderTotal"]);
    setInitialValues(val);
    setFieldsArr(doFields);
    return doFields;
  };

  const getAccountByID = async (ID) => {
    const serv = new APIService();
    const response = await serv.getDataFromBackend(`getaccountbyid?ID=${ID}`);
    return response?.data?.data;
  }

  const handleSelectChange = async (value, backendName, tempAccOptions) => {
    if (backendName === "AccountID") {
      let selectedAccount = null;
      if (accountOptions && accountOptions.length > 0) selectedAccount = accountOptions.find((ele) => ele.value === value);
      else selectedAccount = tempAccOptions.find((ele) => ele.value === value);

      const serv = new APIService();
      const response = await serv.getDataFromBackend(
        `OrderAccountSelection?ID=${value}&ParentAccountID=${selectedAccount?.ParentAccountID}&DistributorID=${selectedAccount?.DistributorID}`
      );
      const manufacturers = response?.data?.Manufacturers;
      const relatedAccs = response?.data?.RelatedAccounts;
      // const caseIDs = response?.data?.CaseIDs;
      const distributor = response?.data?.Distributor;
      const distUser = response?.data?.DistributorUser;

      let tempOptions = [];
      manufacturers.map((ele) => {
        tempOptions.push({
          value: ele.ID,
          label: ele.ManufacturerName,
        });
      });
      setManufacturerOptions(tempOptions);
      setProductColumns(generateProductaSchema());

      tempOptions = [];
      relatedAccs?.map((ele) => {
        tempOptions.push({
          value: ele.ID,
          label: ele.AccountName,
          ParentAccountID: ele.ParentAccountID
        });
      });
      // if (relatedAccs.length !== 1) {
      if (userData.Type === "Distributor") {
        if (selectedAccount.DistributorID === userData.DistributorID) {
          tempOptions.push({
            value: value,
            label: "Self",
            ParentAccountID: selectedAccount.ParentAccountID
          });
        }
      }
      else {
        tempOptions.push({
          value: value,
          label: "Self",
          ParentAccountID: selectedAccount.ParentAccountID
        });
      }

      setRelatedAccountOptions(tempOptions);

      return { distributor, distUser };
    }
    else if (backendName === "ShipToAccountID") {
      const shipToAcc = await getAccountByID(value);
      console.log("ShipToAccount Data: ", shipToAcc);
      const dist = {
        ID: shipToAcc.DistributorID,
        DistributorName: shipToAcc.DistributorName
      }
      const distUser = {
        DistributorUserID: shipToAcc.DistributorUserID,
        DistributorUsername: shipToAcc.DistributorUsername
      }
      const billToAcc = await getAccountByID(shipToAcc.BillingAccountID);
      console.log("BillToAccount Data: ", billToAcc);
      return { billToAcc, dist, distUser };
      // return shipToAcc
    }
    else if (backendName === "BillToAccountID") {
      // const selectedAccountData = await getAccountByID(value);
      // console.log("Account Data: ", selectedAccountData);
      // return selectedAccountData;
    }
  };

  const [isSelect, setIsSelect] = React.useState(false);

  const getProductsFromManufacturer = async (value, accountID) => {
    if (value === null || value === undefined || value === "") {
      return;
    }
    const serv = new APIService();
    // const response = await serv.getDataFromBackend(
    //   `getproductsfrommanufacturer/?ID=${value}`
    // );
    // getproductsfromaccountid
    const response = await serv.getDataFromBackend(`getproductsfromaccountid?AccountID=${accountID}&ManufacturerID=${value}`);
    // console.log("Products from Manufacturer: ", response);
    console.log("Products from Account and Manufacturer: ", response?.data?.data);
    let prodObj = response?.data?.data;
    prodObj = prodObj.map((ele) => {
      ele["Quantity"] = 0;
      ele["ProductTotal"] = 0;
      return ele;
    });
    // setProductData(response?.data?.data);
    console.log("Product Obj: ", prodObj);
    setProductData(prodObj);
    setIsSelect(true);
  };


  const generateProductaSchema = () => {
    const schema = Config.ColumnConfigs.OrderProduct;
    const columns = [];
    for (const cur of schema) {
      if (params?.id !== null && params?.id !== undefined) {
        if (cur.backendName === "StandardPrice") {
          continue;
        }
      }
      // else {
      //   if (cur.backendName === "Price") {
      //     continue
      //   }
      // }
      if (cur.isDisplayed && (cur.isFormatter === false || cur.isFormatter === undefined || cur.isFormatter === null)) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
        });
      } else if (cur.isDisplayed && cur.isFormatter) {
        if (cur.formatterType === "input") {
          columns.push({
            title: cur.displayName,
            dataIndex: cur.backendName,
            key: cur.backendName,
            editable: true,
          });
        }
        else if (cur.formatterType === "non-editableInput") {
          columns.push({
            title: cur.displayName,
            dataIndex: cur.backendName,
            key: cur.backendName,
          });
        }
        else {
          console.log("Invalid Formatter Type");
        }
      }
    }
    return columns;
  };

  const submitHandler = async (values) => {

    console.log("Submit Handler: ", values);
    console.log("Order Products: ", orderProducts);
    if (
      params?.id !== null &&
      params?.id !== undefined &&
      isPrepaidDirectOrderAdminActionLocked(values)
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Order Locked',
        text: 'Prepaid direct orders cannot be edited until payment is successful.',
      });
      return;
    }
    if (params?.id === null || params?.id === undefined) {
      if (orderProducts === null || orderProducts.length === 0 || numberOfProducts === 0 || orderTotal === 0) {
        Swal.fire({
          icon: 'error',
          title: 'No Products Added',
          text: 'Please add products to the order',
        });
        return;
      }
    }
    else {
      console.log("Edit Order Values: ", values);
      console.log("Order Products: ", orderProducts);
      if (numberOfProducts === 0 || orderTotal === 0) {
        Swal.fire({
          icon: 'error',
          title: 'No Products Added',
          text: 'Please add products to the order',
        });
        return;
      }
    }
    // confirmation swal before submittion
    Swal.fire({
      title: 'Are you sure?',
      html: `
    <p><strong>Please note:</strong> Delivery times may vary. To help ensure your order arrives before surgery, please place orders at least <strong>2–3 business days</strong> in advance.</p>
    <p><strong>Returns:</strong> Returns are not guaranteed and must be approved in writing within <strong>5 business days</strong> of receipt. A <strong>re-boxing/relabeling fee</strong> may apply.</p>
    <p><strong>Order cutoff:</strong> 4:00 PM EST, Monday–Friday.</p>
    <p style="margin-top:0.5rem;">For full details, see our <a href="https://www.tissuevault.health/shipping-and-return-policy" target="_blank" rel="noopener noreferrer">Shipping &amp; Return Policy</a>.</p>
  `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, submit it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowLoader(true);
        const apiServe = new APIService();
        let postObj = values;
        // add new key value to postObj
        // map ProductID to ID in orderProducts
        console.log("Order Products: ", orderProducts);
        orderProducts.map((ele) => {
          // ele["ProductID"] = ele["ID"];
          ele["ProductID"] = ele["ProductID"];
          if (ele["Price"] === null) {
            ele["Price"] = ele["StandardPrice"];
          }
          return ele;
        });
        postObj["OrderProducts"] = orderProducts;
        postObj["NumberOfProducts"] = numberOfProducts
        postObj["OrderTotal"] = orderTotal;
        // if(params?id === null || params?.id === undefined){
        // postObj["OrderDate"] = dayjs();
        // }

        // postObj["OrderDate"] = moment().format("MM-DD-YYYY HH:mm:ss");

        console.log("Post Object: ", postObj);
        let methodName = '';
        if (params?.id === null || params?.id === undefined) {
          methodName = 'adddirectorder';
          // return;
          if (values?.PONumber === null || values?.PONumber === undefined || values?.PONumber === "") {
            values.PONumber = null;
          }
          apiServe.addDataToBackend(values, methodName).then(async (response) => {
            console.log("Add Direct Order Response: ", response);
            if (response?.status === 200 || response?.status === 201) {
              setShowLoader(false);
              Swal.fire(
                'Submitted!',
                'Order has been submitted.',
                'success'
              ).then(() => {
                window.location.reload();
              });
            }
            else {
              setShowLoader(false);
              Swal.fire({
                icon: 'error',
                title: 'Order Submission Failed',
                text: 'Please try again',
              });
            }
          }).catch((err) => {
            console.log("Error: ", err);
            setShowLoader(false);
            Swal.fire({
              icon: 'error',
              title: 'Order Submission Failed',
              text: getApiErrorMessage(err, 'Please try again'),
            });
          });
        }
        else {
          console.log("Edit Order Values: ", values);
          methodName = 'updatedirectorder?type=edit';
          // return;
          apiServe.updateDataToBackend(values, methodName).then(async (response) => {
            console.log("Add Direct Order Response: ", response);
            if (response?.status === 200 || response?.status === 201) {
              setShowLoader(false);
              Swal.fire(
                'Submitted!',
                'Order has been submitted.',
                'success'
              ).then(() => {
                window.location.reload();
              });
            }
            else {
              setShowLoader(false);
              Swal.fire({
                icon: 'error',
                title: 'Order Submission Failed',
                text: 'Please try again',
              });
            }
          }).catch((err) => {
            console.log("Error: ", err);
            setShowLoader(false);
            Swal.fire({
              icon: 'error',
              title: 'Order Update Failed',
              text: getApiErrorMessage(err, 'Please try again'),
            });
          });
        }

      }
    });

  };

  const [caseIDOptions, setCaseIDOptions] = React.useState([]);
  const [caseIdMaufacturer, setCaseIdManufacturer] = React.useState(null);

  const getCaseIDsforAccount = async (accountID) => {
    const serv = new APIService();
    const response = await serv.getDataFromBackend(`getcaseidsforaccount?accountID=${accountID}`);
    console.log("Case IDs: ", response?.data?.data);
    let tempOptions = [];
    response?.data?.data.map((ele) => {
      tempOptions.push({
        value: ele.CaseID,
        label: ele.CaseID,
        ID: ele.ID,
        ManufacturerID: ele.ManufacturerID,
        ManufacturerName: ele.ManufacturerName,
      });
    });
    setCaseIDOptions(tempOptions);
  }

  const handleButtonClick = (submitForm) => {
    if (isEditable) {
      submitForm(); // Trigger form submission
    } else {
      setIsEditable(true); // Enable edit mode
    }
  };

  const [shipToContactOptions, setShipToContactOptions] = React.useState(null);
  const [billToContactOptions, setBillToContactOptions] = React.useState(null);
  const [shipToAccountData, setShipToAccountData] = React.useState(null);
  const [billToAccountData, setBillToAccountData] = React.useState(null);

  const getAccountDetails = async (ID) => {
    const serv = new APIService();
    const response = await serv.getDataFromBackend(`getaccountbyid?ID=${ID}`);
    console.log("Account Data: ", response?.data?.data);
    setShipToAccountData(response?.data?.data);
    let accData = response?.data?.data;
    // gett billing account
    const billToAccResponse = await serv.getDataFromBackend(`getaccountbyid?ID=${accData.BillingAccountID}`);
    setBillToAccountData(billToAccResponse?.data?.data);
    // get contact by account
    const contactResponse = await serv.getDataFromBackend(`getcontactsbyaccount?AccountID=${ID}`);
    console.log("Contact Data: ", contactResponse?.data?.data);
    let contacts = contactResponse?.data?.data;
    contacts.map((ele) => {
      ele["value"] = ele.ID;
      ele["label"] = ele.FirstName + " " + ele.LastName;
      return ele;
    });
    setShipToContactOptions(contacts);

    const billContactResponse = await serv.getDataFromBackend(`getcontactsbyaccount?AccountID=${accData.BillingAccountID}`);
    console.log("Billing Contact Data: ", billContactResponse?.data?.data);
    let billContacts = billContactResponse?.data?.data;
    billContacts.map((ele) => {
      ele["value"] = ele.ID;
      ele["label"] = ele.FirstName + " " + ele.LastName;
      return ele;
    });
    setBillToContactOptions(billContacts);
    return accData;
  }
  const [showRejectModal, setShowRejectModal] = React.useState(false);
  const [rejectRemarks, setRejectRemarks] = React.useState('');


  const openRejectModal = () => {
    // console.log("Reject Modal Opened: ", record);
    // setModalData(record);
    setShowRejectModal(true);
  }

  const handleCancel = () => {
    console.log('Clicked cancel button');
    setShowRejectModal(false);
  };

  const [confirmLoading, setConfirmLoading] = React.useState(false);

  const handleOk = async () => {
    if (isPrepaidDirectOrderAdminActionLocked(initialValues)) {
      Swal.fire({
        icon: 'error',
        title: 'Order Locked',
        text: 'Prepaid direct orders cannot be rejected until payment is successful.',
      });
      return;
    }

    setConfirmLoading(true);
    try {
      // approve order
      const apiServe = new APIService();
      const postObj = {
        ID: params?.id,
        Status: "Rejected",
        RejectedBy: userData.FirstName + " " + userData.LastName,
        RejectRemarks: rejectRemarks,
        // RejectedDate: moment().format("MM-DD-YYYY"),
        RejectedDate: dayjs(),
      };
      const response = await apiServe.updateDataToBackend(postObj, `updatedirectorder?type=reject`);
      console.log("Reject Order Response: ", response);
      Swal.fire(
        'Rejected!',
        'Order Rejected Successfully.',
        'success'
      ).then(() => {
        window.location.reload();
      });
      setShowRejectModal(false);
    } catch (err) {
      console.log("Error: ", err);
      Swal.fire({
        icon: 'error',
        title: 'Reject Order Failed',
        text: getApiErrorMessage(err, 'Please try again'),
      });
    } finally {
      setConfirmLoading(false);
    }
  };

  const [showApproveModal, setShowApproveModal] = React.useState(false);
  const [modalData, setModalData] = React.useState({});


  const openApproveModal = (record) => {
    // console.log("Approve Modal Opened: ", record);
    setModalData(record);
    setShowApproveModal(true);
  }

  const handleCancelApprove = () => {
    // console.log('Clicked cancel button');
    setShowApproveModal(false);
  };

  // const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);

  const handleOkApprove = async () => {
    if (isPrepaidDirectOrderAdminActionLocked(initialValues)) {
      Swal.fire({
        icon: 'error',
        title: 'Order Locked',
        text: 'Prepaid direct orders cannot be approved until payment is successful.',
      });
      return;
    }

    setShowApproveModal(false);
    setShowLoader(true);
    setConfirmLoading(true);
    try {
      // approve order
      const apiServe = new APIService();
      const postObj = {
        ID: params?.id,
        Status: "Approved",
        ApprovedBy: userData.FirstName + " " + userData.LastName,
        // ApprovedDate: moment().format("MM-DD-YYYY HH:mm:ss"),
        ApprovedDate: dayjs(),
      };
      const response = await apiServe.updateDataToBackend(postObj, `updatedirectorder?type=approve`);
      // console.log("Approve Order Response: ", response);
      setShowApproveModal(false);
      Swal.fire(
        'Approved!',
        'Order Approved Successfully.',
        'success'
      ).then(() => {
        window.location.reload();
      });
    } catch (err) {
      console.log("Error: ", err);
      Swal.fire({
        icon: 'error',
        title: 'Approve Order Failed',
        text: getApiErrorMessage(err, 'Please try again'),
      });
    } finally {
      setConfirmLoading(false);
      setShowLoader(false);
    }
  };

  // const currentDate = moment().format("MM-DD-YYYY");

  const [showAddContactModal, setShowAddContactModal] = React.useState(false);
  const [shipModalSelected, setShipModalSelected] = React.useState(false);
  const [billModalSelected, setBillModalSelected] = React.useState(false);

  const handleOkAddContact = () => {
    setShowAddContactModal(false);
  }

  const handleCancelAddContact = () => {
    setShowAddContactModal(false);
  }

  const clearManufacturer = (formik) => {
    console.log("Clear Manufacturer");
    setIsSelect(false);
    setDisableCaseID(false);
    setProductData(null);
    formik.setFieldValue("ManufacturerID", null);
    formik.setFieldValue("ManufacturerName", null);
  }

  return (
    <div>
      {showLoader &&
        <Spin fullscreen indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      }
      {initialValues &&
        <CustomHeader leftTopText="Welcome back!"
          leftBottomText={params?.id !== null && params?.id !== undefined ? `PO Number ${initialValues?.PONumber}` : "New Direct Order"}
          rightTopText="Logged in as Admin"
          rightBottomText="User" />
      }
      <div>
        {initialValues && (
          <Formik onSubmit={submitHandler} initialValues={initialValues} validationSchema={validationSchema}>
            {(formik) => (
              // console.log("formik: ", formik),
              <form onSubmit={formik.handleSubmit}>
                {params?.id !== null && params?.id !== undefined &&

                  <div>
                    {userData.Type === "Admin" && !isPrepaidDirectOrderAdminActionLocked(formik.values) &&
                      <div style={{ display: 'flex', gap: '16px', margin: '30px 0px 30px 0px' }}>
                        {hasPermission(userData, "order.edit") &&
                          <Button
                            type="primary"
                            style={{ marginBottom: 16, background: isEditable ? '#27a907' : '#ff9202' }}
                            onClick={() => handleButtonClick(formik.handleSubmit)}
                          >
                            {isEditable ? 'Save Changes' : 'Edit'}
                          </Button>
                        }
                        {(formik.values.Status === "Pending") && hasPermission(userData, "order.manage") &&
                          <div>
                            <Button type="primary" onClick={openRejectModal} style={{ background: '#ff0000' }}>Reject with Remarks</Button>
                            <Button type="primary" onClick={openApproveModal} icon={<CheckOutlined />} iconPosition="start" style={{ background: '#27a907', marginLeft: '16px' }}>Approve</Button>
                          </div>
                        }
                      </div>
                    }
                    <Row gutter={16}>
                      <Col span={6} style={{ width: '100%' }}>
                        <label className="form-label">PO Number</label>
                        <Input
                          name="PONumber"
                          value={formik.values.PONumber}
                          onChange={(event) => formik.setFieldValue('PONumber', event.target.value)}
                          defaultValue={formik.values.PONumber}
                          disabled={!isEditable}
                        />
                      </Col>
                      {formik.values.Status !== "Pending" &&
                        <Col span={6} style={{ width: '100%' }}>
                          <label className="form-label">Tracking Number</label>
                          <Input
                            name="TrackingNumber"
                            value={formik.values.TrackingNumber}
                            onChange={(event) => formik.setFieldValue('TrackingNumber', event.target.value)}
                            defaultValue={formik.values.TrackingNumber}
                            disabled={!isEditable}
                          />
                        </Col>
                      }
                    </Row>
                    <Row gutter={16}>
                      <Col span={6} style={{ width: '100%' }}>
                        <label className="form-label">Status</label>
                        <Select
                          name="PONumber"
                          value={{ label: formik.values.Status, value: formik.values.Status }}
                          onChange={(selectedOption) => {
                            formik.setFieldValue("Status", selectedOption.value);
                          }}
                          options={[
                            { value: "Pending", label: "Pending" },
                            { value: "Approved", label: "Approved" },
                            { value: "Shipped", label: "Shipped" },
                            ...(["In Transit", "Delayed", "Delivered"].includes(formik.values.Status) ? [{ value: formik.values.Status, label: formik.values.Status }] : []),
                            { value: "Rejected", label: "Rejected" },
                            { value: "Completed", label: "Completed" },
                          ]}
                          // disabled={!isEditable}
                          // isDisabled={!isEditable}
                          isDisabled={formik.values.Status !== "Pending" ? true : !isEditable}
                        />
                      </Col>
                      {(formik.values.Status === "Approved" || ["Shipped", "In Transit", "Delayed", "Delivered"].includes(formik.values.Status) || formik.values.Status === "Completed") &&
                        <>
                          <Col span={6} style={{ width: '100%' }}>
                            <label className="form-label">Approved Date and Time</label>
                            {/* <DatePicker
                              format="MM-DD-YYYY"
                              showTime
                              onBlur={() => formik.setFieldTouched("ApprovedDate")}
                              value={formik.values["ApprovedDate"]}
                              // value={tempDate}
                              disabled
                              style={{ width: '100%' }}
                            /> */}
                            <Input
                              name="ApprovedDate"
                              value={dayjs(formik.values.ApprovedDate).format("MM-DD-YY - HH:mm").toString()}
                              disabled
                            />
                          </Col>
                          <Col span={6} style={{ width: '100%' }}>
                            <label className="form-label">Approved By</label>
                            <Input
                              name="ApprovedBy"
                              value={formik.values.ApprovedBy}
                              // onChange={(event) => formik.setFieldValue('ApprovedBy', event.target.value)}
                              defaultValue={formik.values.ApprovedBy}
                              disabled
                            />
                          </Col>
                        </>
                      }
                      {formik.values.Status === "Rejected" &&
                        <>
                          <Col span={6} style={{ width: '100%' }}>
                            <label className="form-label">Rejected Date</label>
                            <DatePicker
                              format="MM-DD-YYYY"
                              onBlur={() => formik.setFieldTouched("RejectedDate")}
                              title={formik.values["RejectedDate"]}
                              value={formik.values["RejectedDate"]}
                              disabled
                              style={{ width: '100%' }}
                            />
                            <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>
                          </Col>
                          <Col span={6} style={{ width: '100%' }}>
                            <label className="form-label">Rejected By</label>
                            <Input
                              name="RejectedBy"
                              value={formik.values.RejectedBy}
                              style={{ width: '100%' }}
                              // onChange={(event) => formik.setFieldValue('RejectedBy', event.target.value)}
                              defaultValue={formik.values.RejectedBy}
                              disabled
                            />
                          </Col>
                          <Col span={6} style={{ width: '100%' }}>
                            <label className="form-label">Reject Remarks</label>
                            <Input
                              name="RejectRemarks"
                              value={formik.values.RejectRemarks}
                              // onChange={(event) => formik.setFieldValue('RejectedBy', event.target.value)}
                              defaultValue={formik.values.RejectRemarks}
                              disabled
                            />
                          </Col>
                        </>
                      }
                    </Row>
                  </div>
                }
                <Modal
                  title="Reject Order?"
                  open={showRejectModal}
                  onOk={handleOk}
                  confirmLoading={confirmLoading}
                  onCancel={handleCancel}
                  centered={true}
                  footer={false}
                >
                  <p>This action will mark the order as rejected, and will notify the sender via email. Please add any remarks for the sender</p>
                  <strong><label className="form-label">Remarks (optional)</label></strong>
                  <TextArea
                    name="RejectRemarks"
                    value={rejectRemarks}
                    onChange={(event) => setRejectRemarks(event.target.value)}
                    placeholder="Add remarks here..."
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  // defaultValue={formik.values.DistributorName}
                  // disabled
                  />
                  <Button type="primary" onClick={handleOk} style={{ background: '#ff0000', marginTop: '10px' }}>Reject with Remarks</Button>
                </Modal>
                <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', marginBottom: '30px' }}>
                  <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Order Details</p>
                </div>
                <Row gutter={16}>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Account Name <span style={{ color: 'red' }}>*</span></label>
                    <Select
                      onBlur={() => formik.setFieldTouched("AccountID")}
                      // title={formik.values["AccountID"]}
                      value={{ label: formik.values["AccountName"], value: formik.values["AccountID"] }}
                      // onChange={async (value, option) => {
                      onChange={async (selectedOption) => {
                        console.log("Value: ", selectedOption.value);
                        console.log("Option: ", selectedOption);
                        formik.setFieldValue("AccountName", selectedOption.label);
                        formik.setFieldValue("AccountID", selectedOption.value);
                        const { distributor, distUser } = await handleSelectChange(selectedOption.value, "AccountID");
                        // console.log("Distributor Data: ", distributor);
                        // formik.setFieldValue("DistributorID", distributor?.ID);
                        // formik.setFieldValue("DistributorName", distributor?.DistributorName);
                        // formik.setFieldValue("DistributorUserID", distUser?.DistributorUserID);
                        // formik.setFieldValue("DistributorUsername", distUser?.DistributorUsername);
                        // formik.setFieldValue("OrderPlacedBy", distUser?.DistributorUsername);
                      }}
                      // style={{ width: 120 }}
                      style={{ width: '100%' }}
                      defaultValue=""
                      options={accountOptions}
                      isDisabled={params?.id !== null && params?.id !== undefined ? true : false}
                    />
                    {formik.errors["AccountID"] && formik.touched["AccountID"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["AccountID"]}</div>
                    ) : null}
                    <p className='input-subtitle'>Choose from accounts under your scope</p>
                  </Col>

                  <Col span={6}>
                    <label className="form-label">Order Placed By</label>
                    <Input
                      name="OrderPlacedBy"
                      value={formik.values.OrderPlacedBy}
                      // onChange={(event) => formik.setFieldValue('OrderPlacedBy', event.target.value)}
                      disabled
                    />
                    <p className='input-subtitle'>This cannot be edited</p>
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Order Type</label>
                    <Input
                      name="OrderType"
                      value={formik.values.OrderType}
                      // onChange={(event) => formik.setFieldValue('OrderType', event.target.value)}
                      disabled
                    />
                    <p className='input-subtitle'>This cannot be edited</p>
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Order Date</label>
                    {isEditable === true &&
                      <DatePicker
                        format="MM-DD-YYYY"
                        onBlur={() => formik.setFieldTouched("OrderDate")}
                        onChange={(date, dateString) => {
                          formik.setFieldValue("OrderDate", date);
                        }}
                        title={formik.values["OrderDate"]}
                        value={formik.values["OrderDate"]}
                        disabled={(params?.id === null || params?.id === undefined) ? true : !isEditable}
                        style={{ width: '100%' }}
                      />
                    }
                    {isEditable === true &&
                      <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>
                    }
                    {isEditable === false &&
                      <Input
                        name="OrderDate"
                        value={(params?.id === null || params?.id === undefined) ? dayjs(formik.values.OrderDate).format("MM-DD-YY").toString() : dayjs(formik.values.OrderDate).format("MM-DD-YY - HH:mm").toString()}
                        disabled
                      />
                    }
                    <p className='input-subtitle'>This cannot be edited</p>
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Requested Delivery Date</label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("RequestedDeliveryDate")}
                      title={formik.values["RequestedDeliveryDate"]}
                      value={formik.values["RequestedDeliveryDate"]}
                      onChange={(date, dateString) =>
                        formik.setFieldValue(
                          "RequestedDeliveryDate",
                          date
                        )
                      }
                      style={{ width: '100%' }}
                      disabledDate={(currentDate) =>
                        currentDate && (currentDate < dayjs().add(1, 'days').startOf('day') || currentDate.day() === 0)
                      }
                      disabled={!isEditable}
                    />
                    <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>
                    {/* <p className='input-subtitle'>This cannot be edited</p> */}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Shipping Preference <span style={{ color: 'red' }}>*</span></label>
                    <Select
                      onBlur={() => formik.setFieldTouched("ShippingPreference")}
                      // title={formik.values[ele.backendName]}
                      // placeholder={ele.placeholder}
                      value={{ label: formik.values["ShippingPreference"], value: formik.values["ShippingPreference"] }}
                      // onChange={async (value, option) => {
                      onChange={async (selectedOption) => {
                        formik.setFieldValue("ShippingPreference", selectedOption.value);
                        formik.setFieldValue("ShippingCost", selectedOption.value.split("- $")[1]);
                      }}
                      style={{ width: '100%' }}
                      // defaultValue={{ value: "Priority Overnight by 10:30am", label: "Priority Overnight by 10:30am" }}
                      placeholder="Select Shipping Preference"
                      options={[
                        // { value: "First Class Overnight by 8:30am", label: "First Class Overnight by 8:30am" },
                        // { value: "Priority Overnight by 10:30am", label: "Priority Overnight by 10:30am" },
                        // { value: "Standard Overnight by 5pm", label: "Standard Overnight by 5pm" },
                        // { value: "Fedex 2-day AM", label: "Fedex 2-day AM" },
                        // { value: "Fedex 2-day", label: "Fedex 2-day" },
                        { value: "First Overnight by 8:00 AM - $200", label: "First Overnight by 8:00 AM - $200" },
                        { value: "Priority Overnight by 10:30 AM - $150", label: "Priority Overnight by 10:30 AM - $150" },
                        { value: "Standard Overnight by 5:00 PM - $100", label: "Standard Overnight by 5:00 PM - $100" },
                        { value: "2-Day AM by 10:30 AM - $50", label: "2-Day AM by 10:30 AM - $50" },
                        { value: "2-Day by 5:00 PM - $10", label: "2-Day by 5:00 PM - $10" }
                      ]}
                      isDisabled={!isEditable}
                    />
                    {formik.errors["ShippingPreference"] && formik.touched["ShippingPreference"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["ShippingPreference"]}</div>
                    ) : null}
                  </Col>
                  {params?.id === null || params?.id === undefined &&
                    <Col span={6} style={{ width: '100%' }}>
                      <label className="form-label">Custom PO Number (optional) </label>
                      <Input
                        name="PONumber"
                        value={formik.values.PONumber}
                        onChange={(event) => formik.setFieldValue('PONumber', event.target.value)}
                        disabled={!isEditable}
                      />
                      <p className='input-subtitle'>PO Number will be auto-generated if left empty</p>
                    </Col>
                  }
                </Row>
                <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', marginBottom: '20px' }}>
                  <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Shipping Details</p>
                </div>

                <Row gutter={16}>
                  <Col span={6}>
                    <label className="form-label">Ship to Account <span style={{ color: 'red' }}>*</span></label>
                    <Select
                      onBlur={() => formik.setFieldTouched("ShipToAccountID")}
                      // title={formik.values[ele.backendName]}
                      // placeholder={ele.placeholder}
                      value={{ label: formik.values["ShipToAccountName"], value: formik.values["ShipToAccountID"] }}
                      // onChange={async (value, option) => {
                      onChange={async (selectedOption) => {
                        formik.setFieldValue("ShipToAccountName", selectedOption.label === "Self" ? formik.values["AccountName"] : selectedOption.label);
                        formik.setFieldValue("ShipToAccountID", selectedOption.value);
                        const shipObj = await getAccountDetails(selectedOption.value);
                        // formik.setFieldValue("ShipToContactName", shipObj.ContactName);
                        // formik.setFieldValue("ShipToContactID", shipObj.ContactName);
                        formik.setFieldValue("ShipAddressLine1", shipObj?.AddressLine1);
                        formik.setFieldValue("ShipAddressLine2", shipObj?.AddressLine2);
                        formik.setFieldValue("ShipCity", shipObj?.City);
                        formik.setFieldValue("ShipState", shipObj?.State);
                        formik.setFieldValue("ShipZip", shipObj?.Zip);
                        formik.setFieldValue("ShipPhone", shipObj?.Phone);
                        formik.setFieldValue("ShipFax", shipObj?.Fax);
                        const { billToAcc, dist, distUser } = await handleSelectChange(selectedOption.value, "ShipToAccountID");
                        console.log("Account Data Select: ", billToAcc);
                        formik.setFieldValue("BillToAccountID", billToAcc?.ID);
                        formik.setFieldValue("BillToAccountName", billToAcc?.AccountName);
                        formik.setFieldValue("BillAddressLine1", billToAcc?.AddressLine1);
                        formik.setFieldValue("BillAddressLine2", billToAcc?.AddressLine2);
                        formik.setFieldValue("BillCity", billToAcc?.City);
                        formik.setFieldValue("BillState", billToAcc?.State);
                        formik.setFieldValue("BillZip", billToAcc?.Zip);
                        formik.setFieldValue("BillPhone", billToAcc?.Phone);
                        formik.setFieldValue("BillFax", billToAcc?.Fax);

                        console.log("Distributor Data: ", dist);
                        console.log("Distributor User Data: ", distUser);
                        formik.setFieldValue("DistributorID", dist?.ID);
                        formik.setFieldValue("DistributorName", dist?.DistributorName);
                        formik.setFieldValue("DistributorUserID", distUser?.DistributorUserID);
                        formik.setFieldValue("DistributorUsername", distUser?.DistributorUsername);
                        // formik.setFieldValue("OrderPlacedBy", distUser?.DistributorUsername);
                        await getCaseIDsforAccount(selectedOption.value);
                      }}
                      style={{ width: '100%' }}
                      defaultValue=""
                      // onChange={handleChange}
                      options={relatedAccountOptions}
                      // isDisabled={!isEditable}
                      isDisabled={params?.id !== null && params?.id !== undefined ? true : false}
                    />
                    {formik.errors["ShipToAccountID"] && formik.touched["ShipToAccountID"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["ShipToAccountID"]}</div>
                    ) : null}
                  </Col>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Distributor</label>
                    <Input
                      name="DistributorID"
                      value={formik.values.DistributorName}
                      // onChange={(event) => formik.setFieldValue('DistributorID', event.target.value)}
                      defaultValue={formik.values.DistributorName}
                      disabled
                    />
                  </Col>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Distributor User</label>
                    <Input
                      name="DistributorUserID"
                      value={formik.values.DistributorUsername}
                      // onChange={(event) => formik.setFieldValue('DistributorID', event.target.value)}
                      defaultValue={formik.values.DistributorUsername}
                      disabled
                    />
                  </Col>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Ship to Contact Name</label>
                    {/* <span style={{ display: 'flex', justifyContent:'space-between'}}> */}
                    <Row>
                      <Col span={20} align="left">
                        <Select
                          onBlur={() => formik.setFieldTouched("ShipToContactID")}
                          value={{ label: formik.values["ShipToContactName"], value: formik.values["ShipToContactID"] }}
                          onChange={async (selectedOption) => {
                            formik.setFieldValue("ShipToContactID", selectedOption.value);
                            formik.setFieldValue("ShipToContactName", selectedOption.label);
                          }}
                          options={shipToContactOptions}
                          isDisabled={shipToContactOptions ? false : true}
                        />
                      </Col>
                      {(params?.id === null || params?.id === undefined) &&
                        <Col span={4} align="center">
                          <PlusOutlined
                            style={{ fontSize: '36px', color: 'black', backgroundColor: 'white', cursor: 'pointer', borderColor: 'white' }}
                            disabled={isEditable ? (shipToAccountData ? false : true) : true}
                            onClick={() => {
                              // console.log("Add Contact");
                              setShipModalSelected(true);
                              setBillModalSelected(false);
                              setShowAddContactModal(true);
                            }}
                          />
                        </Col>
                      }
                    </Row>
                    {/* </span> */}
                    {/* <Input
                      name="ShipToContactName"
                      value={formik.values.ShipToContactName}
                      onChange={(event) => formik.setFieldValue('ShipToContactName', event.target.value)}
                      disabled={!isEditable}
                    /> */}
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: '20px' }}>
                  <Col span={6}>
                    <label className="form-label">Address Line 1</label>
                    <Input
                      name="ShipAddressLine1"
                      value={formik.values.ShipAddressLine1}
                      // onChange={(event) => formik.setFieldValue('ShipAddressLine1', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Address Line 2</label>
                    <Input
                      name="ShipAddressLine2"
                      value={formik.values.ShipAddressLine2}
                      // onChange={(event) => formik.setFieldValue('ShipAddressLine2', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">City</label>
                    <Input
                      name="ShipCity"
                      value={formik.values.ShipCity}
                      // onChange={(event) => formik.setFieldValue('ShipCity', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={2}>
                    <label className="form-label">State</label>
                    <Input
                      name="ShipState"
                      value={formik.values.ShipState}
                      // onChange={(event) => formik.setFieldValue('ShipState', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={2}>
                    <label className="form-label">ZIP</label>
                    <Input
                      name="ShipZip"
                      value={formik.values.ShipZip}
                      // onChange={(event) => formik.setFieldValue('ShipZip', event.target.value)}
                      disabled
                    />
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: '20px' }}>
                  <Col span={6}>
                    <label className="form-label">Phone</label>
                    <Input
                      name="ShipPhone"
                      value={formik.values.ShipPhone}
                      // onChange={(event) => formik.setFieldValue('ShipPhone', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Fax</label>
                    <Input
                      name="ShipFax"
                      value={formik.values.ShipFax}
                      // onChange={(event) => formik.setFieldValue('ShipFax', event.target.value)}
                      disabled
                    />
                  </Col>
                </Row>

                <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', margin: '30px 0px 20px 0px' }}>
                  <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Billing Details</p>
                </div>

                <Row gutter={16}>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Bill to Account</label>
                    <Select
                      onBlur={() => formik.setFieldTouched("BillToAccountID")}
                      title={formik.values["BillToAccountID"]}
                      value={{ label: formik.values["BillToAccountName"], value: formik.values["BillToAccountID"] }}
                      // value={{ label: "Hi", value: "Hi" }}
                      // defaultValue={{ label: "Hi", value: "Hi" }}
                      // defaultValue={{ label: formik.values["BillToAccountName"], value: formik.values["BillToAccountID"] }}
                      style={{ width: '100%' }}
                      isDisabled={true}
                    />
                  </Col>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Accounts Payable Contact</label>
                    <Row>
                      <Col span={20} align="left">
                        <Select
                          onBlur={() => formik.setFieldTouched("AccountsPayableContactID")}
                          value={{ label: formik.values["AccountsPayableContact"], value: formik.values["AccountsPayableContactID"] }}
                          onChange={async (selectedOption) => {
                            formik.setFieldValue("AccountsPayableContactID", selectedOption.value);
                            formik.setFieldValue("AccountsPayableContact", selectedOption.label);
                          }}
                          options={billToContactOptions}
                          isDisabled={billToContactOptions ? false : true}
                        />
                      </Col>
                      {(params?.id === null || params?.id === undefined) &&
                        <Col span={4} align="center">
                          <PlusOutlined
                            style={{ fontSize: '36px', color: 'black', backgroundColor: 'white', cursor: 'pointer', borderColor: 'white' }}
                            disabled={isEditable ? (billToAccountData ? false : true) : true}
                            onClick={() => {
                              // console.log("Add Contact");
                              setBillModalSelected(true);
                              setShipModalSelected(false);
                              setShowAddContactModal(true);
                            }}
                          />
                        </Col>
                      }
                    </Row>
                    {/* <Input
                      name="AccountsPayableContact"
                      value={formik.values.AccountsPayableContact}
                      onChange={(event) => formik.setFieldValue('AccountsPayableContact', event.target.value)}
                      disabled={!isEditable}
                    /> */}
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: '20px' }}>
                  <Col span={6}>
                    <label className="form-label">Address Line 1</label>
                    <Input
                      name="BillAddressLine1"
                      value={formik.values.BillAddressLine1}
                      // onChange={(event) => formik.setFieldValue('BillAddressLine1', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Address Line 2</label>
                    <Input
                      name="BillAddressLine2"
                      value={formik.values.BillAddressLine2}
                      // onChange={(event) => formik.setFieldValue('BillAddressLine2', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">City</label>
                    <Input
                      name="BillCity"
                      value={formik.values.BillCity}
                      // onChange={(event) => formik.setFieldValue('BillCity', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={2}>
                    <label className="form-label">State</label>
                    <Input
                      name="BillState"
                      value={formik.values.BillState}
                      // onChange={(event) => formik.setFieldValue('BillState', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={2}>
                    <label className="form-label">ZIP</label>
                    <Input
                      name="BillZip"
                      value={formik.values.BillZip}
                      // onChange={(event) => formik.setFieldValue('BillZip', event.target.value)}
                      disabled
                    />
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: '20px' }}>
                  <Col span={6}>
                    <label className="form-label">Phone</label>
                    <Input
                      name="BillPhone"
                      value={formik.values.BillPhone}
                      // onChange={(event) => formik.setFieldValue('BillPhone', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Fax</label>
                    <Input
                      name="BillFax"
                      value={formik.values.BillFax}
                      // onChange={(event) => formik.setFieldValue('BillFax', event.target.value)}
                      disabled
                    />
                  </Col>
                </Row>

                <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', margin: '30px 0px 20px 0px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', height: '36px' }}>
                  <p style={{ fontWeight: '600', fontSize: '18px', color: '#2d2d2d' }}>Procedure Details</p>
                  <p style={{ fontWeight: '500', fontSize: '12px', color: '#2d2d2d' }}>(Optional, but highly recommended)</p>
                </div>

                <Row gutter={16}>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Physician's Name</label>
                    <Input
                      name="PhysicianName"
                      value={formik.values.PhysicianName}
                      onChange={(event) => formik.setFieldValue('PhysicianName', event.target.value)}
                      disabled={!isEditable}
                    />
                    {formik.errors["PhysicianName"] && formik.touched["PhysicianName"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["PhysicianName"]}</div>
                    ) : null}
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: '20px' }}>
                  <Col span={6}>
                    <label className="form-label">Patient's First Name Initials</label>
                    <Input
                      name="PatientFirstName"
                      value={formik.values.PatientFirstName}
                      onChange={(event) => formik.setFieldValue('PatientFirstName', event.target.value)}
                      disabled={!isEditable}
                    />
                    {formik.errors["PatientFirstName"] && formik.touched["PatientFirstName"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["PatientFirstName"]}</div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Patient's Last Name Initials</label>
                    <Input
                      name="PatientLastName"
                      value={formik.values.PatientLastName}
                      onChange={(event) => formik.setFieldValue('PatientLastName', event.target.value)}
                      disabled={!isEditable}
                    />
                    {formik.errors["PatientLastName"] && formik.touched["PatientLastName"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["PatientLastName"]}</div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Case ID</label>
                    <Select
                      onBlur={() => formik.setFieldTouched("CaseID")}
                      // title={formik.values[ele.backendName]}
                      // placeholder={ele.placeholder}
                      value={{ label: formik.values["CaseID"], value: formik.values["CaseID"] }}
                      // onChange={(value) => handleSelectChange(value, ele.backendName)}
                      onChange={async (selectedOption) => {
                        // formik.setFieldValue("Case", option.label);
                        formik.setFieldValue("CaseID", selectedOption.value);
                        formik.setFieldValue("ManufacturerID", selectedOption.ManufacturerID);
                        formik.setFieldValue("ManufacturerName", selectedOption.ManufacturerName);
                        await getProductsFromManufacturer(selectedOption.ManufacturerID, formik.values["AccountID"]);
                      }}
                      style={{ width: 120 }}
                      defaultValue=""
                      // onChange={handleChange}
                      options={caseIDOptions}
                      // disabled={editMode ? !ele.isEditable : ele.isEditable}
                      isDisabled={isEditable === false ? true : disableCaseID}
                    />
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: '20px' }}>
                  <Col span={6}>
                    <label className="form-label">Date of Application</label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("DateOfApplication")}
                      title={formik.values["DateOfApplication"]}
                      // placeholder={ele.placeholder}
                      value={formik.values.DateOfApplication}
                      onChange={(date, dateString) =>
                        formik.setFieldValue(
                          "DateOfApplication",
                          date
                        )
                      }
                      style={{ width: '100%' }}
                      disabledDate={(currentDate) =>
                        currentDate && (currentDate < dayjs().add(0, 'days').startOf('day'))
                      }
                      // disabled={editMode ? !ele.isEditable : ele.isEditable}
                      disabled={!isEditable}
                    />
                    <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Application Number</label>
                    <Input
                      name="ApplicationNumber"
                      value={formik.values.ApplicationNumber}
                      onChange={(event) => formik.setFieldValue('ApplicationNumber', event.target.value)}
                      disabled={!isEditable}
                    />
                    {formik.errors["ApplicationNumber"] && formik.touched["ApplicationNumber"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["ApplicationNumber"]}</div>
                    ) : null}
                  </Col>
                </Row>
                <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', margin: '30px 0px 20px 0px' }}>
                  <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Direct Order Products</p>
                </div>
                <Form layout='vertical'>
                  <Row gutter={16} style={{ marginBottom: '10px' }}>
                    <Col span={6} style={{ width: '100%' }}>
                      <label className="form-label">Manufacturer</label>
                      <Row gutter={16}>
                        <Col span={20}>
                          <Select
                            onBlur={() => formik.setFieldTouched("ManufacturerID")}
                            // title={formik.values[ele.backendName]}
                            // placeholder={ele.placeholder}
                            value={{ value: formik.values["ManufacturerID"], label: formik.values["ManufacturerName"] }}
                            // onChange={(value) => handleSelectChange(value, ele.backendName)}
                            onChange={async (selectedOption) => {
                              formik.setFieldValue("ManufacturerName", selectedOption.label);
                              formik.setFieldValue("ManufacturerID", selectedOption.value);
                              await getProductsFromManufacturer(selectedOption.value, formik.values["AccountID"]);
                            }}
                            style={{ width: 120 }}
                            defaultValue=""
                            // onChange={handleChange}
                            options={manufacturerOptions}
                            // disabled={editMode ? !ele.isEditable : ele.isEditable}
                            isDisabled={(!isEditable || formik.values["ManufacturerID"] !== null)}
                          />
                        </Col>
                        {(params?.id === null || params?.id === undefined) &&
                          <Col span={4} align="center">
                            {formik.values["ManufacturerID"] &&
                              <ClearOutlined
                                style={{ fontSize: '36px', cursor: 'pointer' }}
                                onClick={() => clearManufacturer(formik)}
                              />
                            }
                          </Col>
                        }
                      </Row>
                      <p className='input-subtitle'>Based on Case ID selected</p>
                    </Col>
                  </Row>
                </Form>

                {isSelect && (
                  <div>
                    <OrderProducts data={(params?.id !== null && params?.id !== undefined) ? orderProducts : productData} columns={productColumns} handleOrderProducts={handleOrderProducts} numProds={formik.values.NumberOfProducts} ordTot={formik.values.OrderTotal} isEdit={params?.id !== null && params?.id !== undefined} isEditable={isEditable} AccountID={accId} ManufacturerID={manId} />

                  </div>
                )}
                {params?.id === null || params?.id === undefined &&
                  <div style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                    <Button onClick={formik.handleSubmit} type='primary' icon={<CheckOutlined />} style={{ background: '#27a907', fontSize: '14px', fontWeight: '600' }}>Submit</Button>
                  </div>
                }
                {params?.id !== null && params?.id !== undefined && formik.values.Status === "Pending" && userData.Type === "Admin" && hasPermission(userData, "order.manage") && !isPrepaidDirectOrderAdminActionLocked(formik.values) &&
                  <div style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                    <Button type='primary' onClick={openApproveModal} icon={<CheckOutlined />} style={{ background: '#27a907', fontSize: '14px', fontWeight: '600' }}>Approve</Button>
                  </div>
                }
                {showApproveModal &&
                  <div>
                    <Modal
                      title="Are you sure you want to approve this order?"
                      open={showApproveModal}
                      onOk={handleOkApprove}
                      confirmLoading={confirmLoading}
                      onCancel={handleCancelApprove}
                      centered={true}
                      footer={false}
                    >
                      <p>This action will send the order to the manufacturer for processing.</p>
                      <Button type="primary" onClick={handleOkApprove} style={{ background: '#27a907' }}>Approve</Button>
                    </Modal>
                  </div>
                }
                {showAddContactModal && shipToAccountData && shipModalSelected &&
                  <div>
                    <Modal
                      title="New Contact"
                      open={showAddContactModal}
                      onOk={handleOkAddContact}
                      confirmLoading={confirmLoading}
                      onCancel={handleCancelAddContact}
                      centered={true}
                      footer={false}
                    >
                      <AddContactForm accountData={shipToAccountData} />
                    </Modal>
                  </div>
                }
                {showAddContactModal && shipToAccountData && billModalSelected &&
                  <div>
                    <Modal
                      title="New Contact"
                      open={showAddContactModal}
                      onOk={handleOkAddContact}
                      confirmLoading={confirmLoading}
                      onCancel={handleCancelAddContact}
                      centered={true}
                      footer={false}
                    >
                      <AddContactForm accountData={billToAccountData} />
                    </Modal>
                  </div>
                }
              </form>
            )}
          </Formik>
        )}

      </div>

    </div>
  );
};

export default DirectOrder;
